import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Nav from './components/Nav';
import Hero from './components/Hero';
import About from './components/About';
import Education from './components/Education';
import Projects from './components/Projects';
import Contact from './components/Contact';
import Footer from './components/Footer';
import TidelineDocs from './components/TidelineDocs';

const divider = (
  <div style={{
    width: '100%', maxWidth: '900px', margin: '0 auto',
    height: '0.5px', background: 'rgba(100,98,92,0.15)',
  }} />
);

function Portfolio() {
  return (
    <div style={{ background: '#f4f3f0', minHeight: '100vh' }}>
      <Nav />
      <main style={{ paddingTop: '56px' }}>
        <Hero />
        {divider}
        <About />
        {divider}
        <Education />
        {divider}
        <Projects />
        {divider}
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Portfolio />} />
        <Route path="/docs/tideline" element={<TidelineDocs />} />
      </Routes>
    </BrowserRouter>
  );
}
